export enum config {
    ENV = "qa",
}
 
